<template>
  <div>

  </div>
</template>

<script>
import * as xhr from '../api/xhr.js'
import * as qconst from '../vendor/qconstants';
import {getGlobalValue, getGlobalValueOrZero, setGlobalKeyValue} from "@/util/globalState";
import {ebus} from "@/vendor/ebus";
import {cloneMe, doReload} from "../vendor/util";
import store from "../store/store";

export default {
  data: () => ({}),
  created() {
    ebus.$on('fastUpdateInventory', (checkoutItems) => {
      if (!this.$store.state.enableBestand) {
        return;
      }
      const inventoryData = getGlobalValue('inventoryData') || [];
      let anyItem = false;

      for (let item of checkoutItems) {
        const itemPosId = item.posId;
        if (itemPosId) {
          let iData = inventoryData.find(i => i.posId === itemPosId);
          if (iData) {
            anyItem = true;
            iData.currentStock -= item.count;
            console.log('fastUpdateInventory reduced currentStock by ' + item.count);
            if (iData.currentStock < 0) {
              iData.currentStock = 0;
            }
          }
        }
      }

      if (anyItem) {
        setGlobalKeyValue('inventoryData', inventoryData);

        store.commit('triggerRefreshFoodMenu', true)
        store.commit('triggerRefreshDrinkMenu', true)

        // const foodMenuOrg = cloneMe(store.getters.foodMenu);
        // const foodMenuFake = cloneMe(foodMenuOrg);
        // foodMenuFake.push({categoryDE:"_", items:[]});
        // store.commit('foodMenu', foodMenuFake);
        // setTimeout(() => {
        //   store.commit('foodMenu', foodMenuOrg);
        // }, 100);
        //
        // const drinkMenuOrg = cloneMe(store.getters.drinkMenu);
        // const drinkMenuFake = cloneMe(drinkMenuOrg);
        // foodMenuFake.push({categoryDE:"_", items:[]});
        // store.commit('drinkMenu', drinkMenuFake);
        // setTimeout(() => {
        //   store.commit('drinkMenu', drinkMenuOrg);
        // }, 200);
      }
    });
    ebus.$on('appFocused', () => {
      this.loadInventoryData();
    });
  },
  beforeMount() {
    this.loadInventoryData();
  },
  mounted() {
    this.loadInventoryData();
    if (this.$store.getters.isKiosk) {
      setInterval(() => {
        this.loadInventoryData();
      }, 40 * 1000);
    }
  },
  methods: {
    async loadInventoryData(notifyUser) {
      if (!this.$store.state.enableBestand) {
        return;
      }
      let now = Date.now();
      let easer = getGlobalValueOrZero('loadInventoryData');
      if (!easer || now - parseInt(easer) > 10 * 1000) {
        setGlobalKeyValue('loadInventoryData', now);
      } else {
        //eased
        return;
      }

      let storeId = "1";
      let msg = {
        action: qconst.action$qsignal_LoadDocs,
        collectionName: 'inventoryDataStore' + storeId,
        // businessPrefix: true,
        query: {
          // itemIdType: itemIdType,
          enabled: true,
        }
      };
      //triggers a broadcast to waiters
      await xhr.xhrSend(true, msg, (data) => {
        if (data?.ok && data.docs) {
          setGlobalKeyValue('inventoryData', data.docs);
          console.log('number of enabled inventoryData loaded: ' + data.docs.length)
          ebus.$emit(qconst.notify$foodsUpdated, {force: false});
          ebus.$emit(qconst.notify$drinksUpdated, {force: false});

          store.commit('triggerRefreshFoodMenu', true)
          store.commit('triggerRefreshDrinkMenu', true)
        } else {
          console.log('error loading inventoryDataStore');
          //retry
          setTimeout(() => {
            this.loadInventoryData();
          }, 10 * 1000);
        }
      }, (err) => {
        console.log('unexpected error loading inventoryDataStore');

        //retry
        setTimeout(() => {
          this.loadInventoryData();
        }, 10 * 1000);
      });
    },

  },
}
</script>

<style scoped>

</style>
